export enum UseType {
  REQUIRED = "REQUIRED",
  OPTIONAL = "OPTIONAL",
  RECOMMENDED = "RECOMMENDED",
}
